import React, { Component } from "react";

class PrivacyPolicy extends Component {

    render() {
        return (
            <div className="terms">
                <div className="container">
                    <ol className="breadcrumb">
                        <li><a href="/">Home &gt;</a></li>
                        <li className="active">Privacy Policy</li>
                    </ol>
                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>Disclaimer</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <p><strong>Important:</strong> UK Tax & Salary Assist is an independent app and is not affiliated with HMRC or any UK government agency. Tax calculations are based on publicly available UK tax guidelines for informational purposes only.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>1. UK Tax & Salary Assist - Privacy Notice</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <p>This Privacy Policy explains how we handle and protect your personal data and your privacy rights under the law. Our trading name is UK Tax & Salary Assist and we are a part of Innovotech Solutions Ltd, a company registered in England & Wales (company number: 10641546) with our registered office at 128 City Road, London, England, EC1V 2NX. As the data controller, we are responsible for your personal data and will refer to ourselves as "UK Tax & Salary Assist", "we", "us", or "our" in this Privacy Policy. If you have any questions or requests to exercise your rights, please contact us at info@websafe365.com.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>2. Data Collection</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <p>We collect financial details such as salary, dividends, rental income, and other data necessary to calculate tax estimates. These details are used solely to provide the requested tax-related services and to improve our platform’s accuracy and functionality.</p>
                                    <p>NOTICE: We do not intentionally collect sensitive personal data such as national insurance numbers or banking details.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>3. Data Sharing</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <p>We may share your data with third-party service providers such as cloud storage providers and API service providers to process tax calculations and manage service delivery. These providers are contractually bound to keep your data confidential, secure, and only use it as directed by us.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>4. Processing by Third Parties</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <p>We may share limited data with trusted third-party service providers for service delivery, troubleshooting, and improvement of app features. These providers are required to process your data securely and only under our instructions.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>5. Disclosing Your Personal Data</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <p>We may disclose your data in the event of business transfers, legal obligations, or to protect our rights. Your data may be processed outside the EEA, subject to secure data handling policies.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="block">
                        <div className="container">
                            <div className="section-title">
                                <div className="description custom-header">
                                    <h2>6. Contact Us</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <p>If you have any questions, concerns about this Privacy Policy or if you would like to delete your account, please contact us at info@websafe365.com.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    };
}

export default PrivacyPolicy;
